import React, { useState, useEffect, useContext } from 'react';
import { LoginModal, PublicNav } from '@components';
import { AuthContext } from '@context';

const HomePage = () => {
    const { auth } = useContext(AuthContext);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [modalInitialStep, setModalInitialStep] = useState('login');

    // 이미 로그인 상태에서 비밀번호 강제 변경이 필요한 경우 모달 자동 오픈
    useEffect(() => {
        if (auth.isAuthenticated && auth.forceChangePw === 'Y') {
            setModalInitialStep('change-password');
            setLoginModalOpen(true);
        }
    }, [auth.isAuthenticated, auth.forceChangePw]);

    const handleModalClose = () => {
        setLoginModalOpen(false);
        setModalInitialStep('login');
    };

    return (
        <div style={{ backgroundColor: '#f4f6f9', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>

            <PublicNav onLoginClick={() => setLoginModalOpen(true)} />

            {/* 메인 콘텐츠 */}
            <main style={{ flexGrow: 1 }}>
                {/* 메인 배너 (차분한 기업형 다크 네이비 톤으로 수정) */}
                <section className="text-white text-center py-5" style={{ backgroundColor: '#1e2b3c', padding: 'max(3rem, 5vw) 1rem' }}>
                    <div className="container py-4 py-md-5">
                        <h1 className="fw-bold mb-4" style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)' }}>안전한 작업 환경, <br />중대재해 Zero를 향한 첫걸음</h1>
                        <p className="lead mb-5 fw-light text-light opacity-75">
                            중대재해처벌법 완벽 대응을 위한 스마트 안전 보건 관리 체계.<br />
                            상단 메뉴를 통해 플랫폼의 주요 기능을 확인해 보세요.
                        </p>
                        <button
                            className="btn btn-primary btn-lg px-5 py-3 fw-bold shadow-sm"
                            style={{ borderRadius: '4px' }}
                            onClick={() => setLoginModalOpen(true)}
                        >
                            <i className="fa-solid fa-shield-halved me-2"></i> 시스템 시작하기
                        </button>
                    </div>
                </section>

                {/* 기능 카드 섹션 */}
                <section className="container py-5 mt-3">
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="card h-100 border shadow-sm text-center p-4">
                                <div className="card-body">
                                    <div className="text-primary mb-3">
                                        <i className="fa-solid fa-chart-pie fa-3x"></i>
                                    </div>
                                    <h5 className="card-title fw-bold text-dark mt-3">실시간 대시보드</h5>
                                    <p className="card-text text-muted mt-3" style={{ fontSize: '0.95rem', wordBreak: 'keep-all' }}>
                                        사업장별 안전 현황, 사고 통계, 위험 요인을 한눈에 파악할 수 있는 직관적인 대시보드를 제공합니다.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border shadow-sm text-center p-4">
                                <div className="card-body">
                                    <div className="text-success mb-3">
                                        <i className="fa-solid fa-users-gear fa-3x"></i>
                                    </div>
                                    <h5 className="card-title fw-bold text-dark mt-3">안전 보건 조직 관리</h5>
                                    <p className="card-text text-muted mt-3" style={{ fontSize: '0.95rem', wordBreak: 'keep-all' }}>
                                        안전보건관리책임자, 관리감독자 등 법정 필수 인력의 선임 및 관리 체계를 전산화하여 누락을 방지합니다.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border shadow-sm text-center p-4">
                                <div className="card-body">
                                    <div className="text-danger mb-3">
                                        <i className="fa-solid fa-triangle-exclamation fa-3x"></i>
                                    </div>
                                    <h5 className="card-title fw-bold text-dark mt-3">사고 및 예방 관리</h5>
                                    <p className="card-text text-muted mt-3" style={{ fontSize: '0.95rem', wordBreak: 'keep-all' }}>
                                        아차사고 및 중대재해 발생 이력을 체계적으로 기록하고, 위험성 평가를 통한 사전 예방 조치를 지원합니다.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 border shadow-sm text-center p-4">
                                <div className="card-body">
                                    <div className="text-warning mb-3">
                                        <i className="fa-solid fa-robot fa-3x"></i>
                                    </div>
                                    <h5 className="card-title fw-bold text-dark mt-3">AI알리미</h5>
                                    <p className="card-text text-muted mt-3" style={{ fontSize: '0.95rem', wordBreak: 'keep-all' }}>
                                        AI 기반 안전 보건 질의응답 서비스입니다. 법령, 규정, 예방 조치에 대해 궁금한 사항을 AI에게 바로 문의해 보세요.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* 하단 푸터 (LoginPage와 동일한 디자인 적용) */}
            <div style={{ backgroundColor: "#f5f5f5", fontSize: "1rem", padding: "20px 0" }} className="mt-auto border-top">
                <div className="container my-auto">
                    <div className="copyright text-center my-auto" style={{ color: "#666" }}>
                        <span>Copyright &copy; 안전 센터 1566-3886</span>
                        <span style={{ marginLeft: "10px" }}>
                            <a href="http://www.atos.co.kr/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>주식회사 아토스</a>
                        </span>
                    </div>
                </div>
            </div>

            {/* 로그인 모달 */}
            <LoginModal
                isOpen={loginModalOpen}
                onClose={handleModalClose}
                initialStep={modalInitialStep}
            />
        </div>
    );
};

export { HomePage };
